export default function PawL() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 337 311">
      <path
        fill="#BFE4C8"
        fillRule="evenodd"
        d="M46.468 239.191c20.454 5.466 35.466-.956 47.382-12.784 17.026-16.902 34.77-28.179 57.299-36.475 35.129-12.916 45.027-49.76 21.08-78.464-15.358-18.404-25.056-37.03-31.34-60.149-4.39-16.185-14.173-29.234-34.626-34.7-41.175-11.004-78.318 20.9-79.246 59.288-.633 26.532-6.703 49.128-19.456 72.42-18.441 33.708-2.267 79.86 38.907 90.864Z"
        clipRule="evenodd"
      />
      <path
        fill="#BFE4C8"
        d="M103.661 281.925c18.143 27.774 46.149 35.478 84.445 22.361l-17.512-58.352c-3.024-11.424-10.776-19.006-21.918-22.604-35.171-11.392-65.195 27.691-45.015 58.595ZM177.217 8.13c29.636-15.005 57.752-7.711 84.338 22.758l-44.416 41.793c-8.346 8.385-18.86 11.082-30.316 8.654-36.167-7.685-42.575-56.505-9.606-73.205ZM214.134 258.887c34.149 18.474 66.688 12.496 97.576-18.895l-51.092-48.785c-9.597-9.741-21.72-13.446-34.978-11.584-41.835 5.837-49.515 58.698-11.506 79.264ZM336.374 148.187c-11.013-42.588-36.196-63.992-75.032-65.023-43.229-1.131-63.075 48.466-29.771 74.384 10.548 8.223 22.905 11.06 36.1 7.41l-.005.012 68.708-16.783Z"
      />
    </svg>
  );
}
